
    import '/home/ec2-user/Youlify-Design/components/warning-banner/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["warning-banner-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/warning-banner/index.zh-CN.md?type=demo')
};